import { Centrifuge } from 'centrifuge';

import { rHandler } from '@/plugins/response-handler';

import ChatService from '@/services/API/ChatService';
import { appChat } from '@/plugins/app-chat';

import Base from '../Base';
import ChatMessage from './ChatMessage';

const DEFAULT_API = '/chat';

export default class Chat extends Base {
  /**
   * @param {Object} item - Chat item from server
   */
  constructor({
    id,
    url,
    token,
    channel,
    tag,
    hideInitials,
    replyTo,
    exists_unread_messages: existsUnreadMessages,
  }, noInit) {
    super(id, DEFAULT_API);

    this.tag = tag;
    this.onMessage = () => {};
    this.onClose = () => {};
    this.onOpen = () => {};

    this.hideInitials = hideInitials; // Скрыть инициалы
    this.replyTo = replyTo; // Пользователь, которому отвечают
    this.alertOptions = {};
    this.exists_unread_messages = existsUnreadMessages;
    this.centrifuge = null;

    if (url && !noInit) {
      this.centrifuge = new Centrifuge(url, { token });
      const sub = this.centrifuge.newSubscription(channel);
      sub.on('publication', (ctx) => this.onMessage(new ChatMessage(ctx.data.data)));
      sub.subscribe();
      this.centrifuge.connect();
    } else {
      this.url = url;
      this.token = token;
      this.channel = channel;
    }
  }

  disconnect() {
    if (this.centrifuge) this.centrifuge.disconnect();
  }

  async setAlertMessage(message) {
    this.alertOptions = {
      message,
    };
  }

  getHistory(offset) {
    const params = {
      sort: '-created_at',
      offset,
    };
    if (this.tag) {
      params['search[tag][course_id]'] = this.tag.course_id;
      params['search[tag][course_unit_id]'] = this.tag.course_unit_id;
      params['search[tag][lesson_id]'] = this.tag.lesson_id;
    }
    return rHandler(
      ChatService.getMessages(this.id, params),
      (r) => {
        this.onOpen();
        return r.data.data.map((i) => new ChatMessage(i)).reverse();
      },
    );
  }

  sendMessage({ text, replyId }) {
    const data = {
      message: text,
      reply: replyId,
      tag: this.tag,
    };
    if (Object.keys(this.alertOptions).length > 0) {
      this.alertOptions.message.processedMessage();
      this.alertOptions = {};
    }
    return rHandler(
      ChatService.sendMessage(this.id, data),
      (resp) => {
        if (!this.centrifuge) {
          this.onMessage(new ChatMessage(resp.data.data));
        }
      },
    );
  }

  close() {
    return rHandler(
      ChatService.closeChat(this.id),
      () => {
        if (this.centrifuge) this.centrifuge.disconnect();
        this.onClose();
      },
    );
  }

  /**
   * @param {Function} callback - callback function when message has been sent
   */
  bindOnMessage(callback) {
    this.onMessage = callback;
  }

  /**
   * @param {Function} callback - callback function when chat has been closed
   */
  bindOnClose(callback) {
    this.onClose = callback;
  }

  bindOnOpen(callback) {
    this.onOpen = callback;
  }

  open(data) {
    this.centrifuge = new Centrifuge(this.url, { token: this.token });
    const sub = this.centrifuge.newSubscription(this.channel);
    sub.on('publication', (ctx) => this.onMessage(new ChatMessage(ctx.data.data)));
    sub.subscribe();
    this.centrifuge.connect();

    appChat.set(this, { opened: true, ...data });
    this.exists_unread_messages = false;
  }
}
